import { useDispatch, useSelector } from "react-redux";

import { authOperationPath, selectCurrentUser } from "modules/auth";

import { useOperationState } from "../../../hooks/operationsState";
import { disableCurrentUser2FA, operationPath } from "../store";

export function useUserSettings() {
  const dispatch = useDispatch();
  const currentUser = useSelector(selectCurrentUser);

  const {
    operationError: userError,
    operationLoading: userLoading,
  } = useOperationState(authOperationPath.currentUser, {
    defaultLoading: true,
  });

  const {
    operationError: user2FAError,
    operationLoading: user2FALoading,
    operationSuccess: user2FASuccess,
    clearOperation: user2FAClearOperation,
  } = useOperationState(operationPath.disableTwoFA);

  const handleDisable2FA = (code: string) => {
    dispatch(disableCurrentUser2FA({ code }));
  };

  return {
    currentUser,
    userError,
    userLoading,
    user2FAError,
    user2FALoading,
    user2FASuccess,
    user2FAClearOperation,
    handleDisable2FA,
  } as const;
}
